import { Component, OnInit, OnDestroy } from '@angular/core';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { DepartmentBasic } from 'src/app/models/helpbutton-models/helpbutton-department-basic.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { StaffBasic } from 'src/app/models/helpbutton-models/helpbutton-staff-basic.model';
import { DepartmentGroup } from 'src/app/models/helpbutton-models/helpbutton-department-group.model';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-department-dashboard',
  templateUrl: './helpbutton-department-dashboard.component.html',
  styleUrls: ['./helpbutton-department-dashboard.component.scss']
})
export class HelpbuttonDepartmentDashboardComponent implements OnInit, OnDestroy {

  department: DepartmentBasic;
  staffs;
  groups: Array<DepartmentGroup>;
  devices: Array<DeviceBasic>;
  assignedDevices: Array<DeviceBasic>;
  getDepartmentSubscriptionRefresh: Subscription;
  getDepartmentInfoSubscription: Subscription;
  getStaffsSubscription: Subscription;
  getGroupsSubscription: Subscription;
  getDepartmentDevicesSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackbarService: SnackBarService,
    private departmentsService: DepartmentsHelpbuttonService,
    private staffsService: StaffsHelpbuttonService,
    private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDepartmentInfo();
    this.getStaffs();
    this.getDepartmentSubscriptionRefresh = this.departmentsService.refreshDepartmentListen().subscribe(
      (res) => {
        this.getDepartmentInfo();
      }
    );
  }

  public getDepartmentInfo() {
    const internalId = this.activatedRoute.snapshot.params['departmentid'];
    this.getDepartmentInfoSubscription = this.departmentsService.getDepartmentInfo(internalId).subscribe(
      (res) => {
        this.department = new DepartmentBasic();
        Object.assign(this.department, res['data']['sectionDetails']);
        this.department.DevicesBound = new Array<DeviceBasic>();
        res['data']['sectionDetails']['devicesBound'].forEach(
          (item) => {
            const device = new DeviceBasic();
            Object.assign(device, item);
            this.department.DevicesBound.push(device);
          }
        );
        this.assignedDevices = this.department.DevicesBound;
        this.getGroups();
        this.getDepartmentDevices();
      },
      (error) => {
        this.router.navigate(['../../../departments'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getStaffs() {
    this.getStaffsSubscription = this.staffsService.getStaffs().subscribe(
      (res) => {
        this.staffs = res;
      },
      (error) => {
        this.router.navigate(['../../../departments'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getGroups() {
    this.getGroupsSubscription = this.departmentsService.getGroups(this.department.InternalId).subscribe(
      (res) => {
        const groups = new Array<DepartmentGroup>();
        res['data']['groupList'].forEach(
          (item) => {
            const group = new DepartmentGroup();
            Object.assign(group, item);
            group.StaffList = new Array<StaffBasic>();
            item.staffList.forEach(
              (item2) => {
                const staff = new StaffBasic;
                Object.assign(staff, item2);
                group.StaffList.push(staff);
              }
            );
            groups.push(group);
          }
        );
        this.groups = groups;
      },
      (error) => {
        this.router.navigate(['../../../departments'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getDepartmentDevices() {
    this.getDepartmentDevicesSubscription = this.departmentsService.getDepartmentDevices(this.department.CenterInternalId).subscribe(
      (res) => {
        const devices = new Array<DeviceBasic>();
        res['data']['deviceList'].forEach(
          (item) => {
            const device = new DeviceBasic();
            Object.assign(device, item);
            devices.push(device);
          }
        );
        this.devices = devices;
      },
      (error) => {
        this.router.navigate(['../../../departments'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-columns', 'helpbutton-page.department detail', '/helpbutton/departments', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.departments', '/helpbutton/departments'), new BRoute('helpbutton-page.department detail')]));
  }

  ngOnDestroy() {
    if (this.getDepartmentSubscriptionRefresh) { this.getDepartmentSubscriptionRefresh.unsubscribe(); }
    if (this.getDepartmentInfoSubscription) { this.getDepartmentInfoSubscription.unsubscribe(); }
    if (this.getStaffsSubscription) { this.getStaffsSubscription.unsubscribe(); }
    if (this.getGroupsSubscription) { this.getGroupsSubscription.unsubscribe(); }
    if (this.getDepartmentDevicesSubscription) { this.getDepartmentDevicesSubscription.unsubscribe(); }
  }

}
